import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/HousingTable/component'

export const HousingTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
